// src/app/mobile.routes.ts
import { Routes } from '@angular/router';
import { AccessRightEnum } from '@boshared';
import { accessRightGuardConfig } from '../core/guard/access-right.guard';
import { AppTabsComponent } from '../layout/tabs/tabs.component';
import { ProfileComponent } from './user-setting/profile-setting/profile.component';
import { profileResolver } from './user-setting/profile-setting/services/profile.resolver';

export const mobileRoutes: Routes = [
  {
    path: '', // This path is relative to where mobileRoutes is loaded
    component: AppTabsComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/mobile/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'farms',
        loadChildren: () => import('./farms/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'logbooks',
        loadChildren: () => import('./logbooks/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'iotDevice',
        loadChildren: () => import('./iot-device/mobile/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'irrigation',
        loadChildren: () => import('./irrigation/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'inventory',
        loadChildren: () => import('./inventory/mobile/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'task',
        loadChildren: () => import('./task/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'userSettings',
        loadChildren: () => import('./user-setting/routes').then(m => m.routes),
        ...accessRightGuardConfig([AccessRightEnum.Search])
      },
      {
        path: 'accountMobile',
        loadChildren: () => import('./user-setting/account-mobile/routes').then(m => m.routes)
      },
      {
        path: 'iotSelection',
        loadChildren: () => import('./iot-device/mobile/iot-selection/routes').then(m => m.routes)
      },
      {
        path: 'farmSelection',
        loadChildren: () => import('./farms/farm-selection/routes').then(m => m.routes)
      },
      {
        path: 'taskSelection',
        loadChildren: () => import('./task/task-selection/routes').then(m => m.routes)
      }
    ]
  },
  {
    path: 'profile/:id',
    component: ProfileComponent,
    resolve: { editData: profileResolver },
    data: { title: 'Profile', titleI18n: 'app.userSettings_accountSetting.profile.title' }
  }
];
